import './App.css';

function App() {
  return (
    <div className="App">
     
      <div className="logo">
        <img src="./logo.png" alt="" />
      </div>
      
      <h2 className="">
        Ներբեռնեք հավելվածն այստեղ
      </h2>
      <div className="main">
        {/* <p>
        Payl ապրանքանիշ, հանդիսանալով կենցաղային քիմիայի արտադրող, իր առջև նպատակ է դրել հաշվարկել իր հաճախորդների սպառման ծավալները ամսվա կտրվածքով՝ կախված բնակելի կամ սպասարկման մակերեսից, ընտանիքի անդամների կամ աշխատաքիցների քանակից և այլ ելակետային տվյալներից, բաժանորդագրությամբ արտադրողից ուղիղ մատակարարումներ իրականացնելու միջոցով լուծել տարածքի մաքրությանը վերաբերող բոլոր խնդիրները։
          Տարաները, ոնոնցով կմատակարարվեն հեղուկները, բազմակի օգտագործման են, կտրվեն ի պահ, և, ի տարբերություն խանութից գնված նյութերի տարաների, չեն հայտնվի աղբանոցում և չեն աղտոտի մեր միջավայրը, այլ, բազմիցս ոգտագործվելուց հետո, կվերամշակվեն։
          </p>  
          <p>
          Խնայելով տարաների, լոգիստիկ ծախսերի, խանութների հավելյալ գնագոյացման հաշվին, մենք հնարավորություն ունենք մեր հաճախորդներին առաջարկել լավագույն գին և որակ՝ խնայելով ոչ միայն նրանց ֆինանսական միջոցները, այլև շրջակա միջավայրը։

          Մեր ընկերության համահիմնադիր և գլխավոր տեխնոլոգ Գայանե Տոնոյանը գործող գիտնական քիմիկ է և հանդիսանում է ՀՀ ԳԱԱ Քիմիայի ինստիտուտի գիտաշխատող, և մեր բոլոր արտադրանքները նրա հեղինակային մշակումների արդյունքն են։ Հավելվածի խանութում Դուք կգտնեք ոչ միայն կենցաղային քիմիա, այլև մաքրության հետ առչվող տարբեր բարագաներ։

          Մենք հոգ ենք տանում, որ Դուք ազատվեք ամեն անգամ խանութներից սննդամթերքի հետ նույն զամբյուղում քիմիական նյութերը ձեզ հետ տուն տանելուց, յուրաքանչյուր տարրայի, մատակարարման շղթայի, խանութների եկամուտի համար վճարելուց, մի խոսքով՝ խնայեք, նաև բնությունը։ 

          Այսպիսով, ներբեռնելով հավելվածն ու բաժանորդագրվելով՝ Դուք.

          Ծախսում եք գրագետ
          Ստանում եք որակ
          Խնայում եք՝ ժամանակ, բնությունն ու գումար, իսկ խնայած գումարն ուղղում եք ձեր իսկ բարեկեցության բարձրացմանը։  
          </p> */}

          <h4>Mobile application and website are coming soon!</h4>
          <div className="socialMedia">
          <img src="./appStore.png" alt=""/>
          <img src="./playmarket.png" alt=""/>


          

          </div>
      </div>      
    </div>
  );
}

export default App;


